
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"SERVICES"'></app-infrastructure-header>

<!-- Main Screen which shows the Services and Service Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#service-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> SERVICES</a></li>
			<li class=""><a data-toggle="tab" href="#services-tab" aria-expanded="false"><i class="fa fa-star-o"></i> SERVICE TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Services Tab -->
			<div id="services-tab" class="tab-pane fade">

				<!-- Add Service Type and Options buttons -->
				<button (click)="addServiceClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> ADD
					SERVICE TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedServiceClicked()" [class.disabled]="!isSingleServiceSelected()"><a><em
									class="fa fa-pencil"></em> EDIT</a></li>
						<li (click)="duplicateSelectedServiceClicked()" [class.disabled]="!isSingleServiceSelected()">
							<a><em class="fa fa-clone"></em> DUPLICATE</a>
						</li>
						<li (click)="deleteSelectedServicesClicked()" [class.disabled]="!isAnyServicesSelected()"><a><em
									class="fa fa-remove"></em> DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedServicesToGroupClicked()" [class.disabled]="!isAnyServicesSelected()">
							<a><em class="fa fa-plus"></em> ADD TO GROUP</a>
						</li>
						<li (click)="removeSelectedServicesFromGroupClicked()"
							[class.disabled]="!isAnyServicesSelected()"><a><em class="fa fa-remove"></em> REMOVE FROM
								GROUP</a></li>
						<li (click)="manageServiceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a>
						</li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionForServices"
					[(selected)]="selectedFilterOptionForServices"
					(filterChanged)="onServicesFilterChanged($event)">
				</app-filter-bar>
	
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Services -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllServicesSelected()"
										(change)="setAllServicesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let service of mServices | paginate: {id: 'service_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForServices, totalItems: totalNumberOfServices }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="service.mSelected" /></td>
								<td (click)="editService(service.mService)">{{service.mService.name}}</td>
								<td>
									<ng-container
										*ngIf="service.mService.groups != null && service.mService.groups.length > 0">
										<ng-container *ngFor="let group of service.mService.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Services" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="service_pagination" (pageChange)="pageChangedServices($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Service Instances Tab -->
			<div id="service-instances-tab" class="tab-pane fade active in">

				<!-- Add Service and Options buttons -->
				<button (click)="addServiceInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD SERVICE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedServiceInstanceClicked()"
							[class.disabled]="!isSingleServiceInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedServiceInstanceClicked()"
							[class.disabled]="!isSingleServiceInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedServiceInstancesClicked()"
							[class.disabled]="!isAnyServiceInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedServiceInstancesToGroupClicked()"
							[class.disabled]="!isAnyServiceInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedServiceInstancesFromGroupClicked()"
							[class.disabled]="!isAnyServiceInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageServiceInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
						<li class="divider"></li>
						 <!-- RESET DRIVER -->
						 <li (click)="resetDriverClicked()" [class.disabled]="!isSingleServiceInstanceSelected()"><a><em class="fa fa-retweet"></em>&nbsp;RESET DRIVER</a></li>
					</ul>
				</div>


				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionForServiceInstances"
					[multiple]="true" [(active)]="activeFilterOptionsForServiceInstances"
					(filterChanged)="onServiceInstancesFilterChanged($event)">
				</app-filter-bar>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Service Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllServiceInstancesSelected()"
										(change)="setAllServiceInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Service Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let serviceInstance of mServiceInstances | paginate: {id: 'serviceinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForServiceInstances, totalItems: totalNumberOfServiceInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="serviceInstance.mSelected" /></td>
								<td (click)="editServiceInstance(serviceInstance.mServiceInstance)" (contextmenu)="fetchFunctionList($event, serviceInstance.mServiceInstance)">
									{{serviceInstance.mServiceInstance.name}}</td>
								<td (click)="editServiceInstance(serviceInstance.mServiceInstance)">
									{{serviceInstance.mServiceInstance.service.name}}</td>
								<td>
									<ng-container
										*ngIf="serviceInstance.mServiceInstance.groups != null && serviceInstance.mServiceInstance.groups.length > 0">
										<ng-container *ngFor="let group of serviceInstance.mServiceInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Services" Instances (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="serviceinstance_pagination"
					(pageChange)="pageChangedServiceInstances($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>
		</div>
	</div>
</div>

<!-- Spinner Service-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate">
	<p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance"
	[instanceType]="mInstanceType" [function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>